import { RRIFilterOption } from '../interfaces/filters/filter-options.interface';

export type RRFilterBy<T> =
  | string
  | number[]
  | RRIFilterOption<T>
  | RRIFilterOption<T>[];
